__webpack_require__.p = "/magazin/concursos/giramania/";